// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"46d4b40a","164":"fbcea14f","453":"9b41687b","677":"9498991e"}[chunkId] + ".chunk.js";
};